/**
 * Typed API client for Sites — lightweight site/page builder.
 *
 * Mirrors internal/sites. A site owns pages (addressed by slug); each page
 * carries a JSON block list plus SEO metadata. Sites are published as a unit.
 */

import { apiClient } from '@/lib/apiClient';

export interface Site {
  id: string;
  siteType: string;
  name: string;
  slug: string;
  customDomain?: string | null;
  published: boolean;
}

export interface SitePage {
  id: string;
  slug: string;
  title: string;
  published: boolean;
  updatedAt: string;
}

export async function listSites(): Promise<Site[]> {
  const { data } = await apiClient.get<Site[]>('/sites');
  return data;
}

export interface CreateSiteRequest {
  siteType?: string;
  name: string;
  slug: string;
  customDomain?: string;
}

export async function createSite(req: CreateSiteRequest): Promise<{ id: string }> {
  const { data } = await apiClient.post<{ id: string }>('/sites', req);
  return data;
}

export async function listPages(siteId: string): Promise<SitePage[]> {
  const { data } = await apiClient.get<SitePage[]>(`/sites/${siteId}/pages`);
  return data;
}

export interface UpsertPageRequest {
  slug: string;
  title: string;
  blocks?: unknown;
  seoTitle?: string;
  seoDescription?: string;
  published?: boolean;
}

export async function upsertPage(siteId: string, req: UpsertPageRequest): Promise<{ id: string }> {
  const { data } = await apiClient.post<{ id: string }>(`/sites/${siteId}/pages`, req);
  return data;
}

export async function publishSite(siteId: string, publish: boolean): Promise<{ ok: boolean }> {
  const { data } = await apiClient.post<{ ok: boolean }>(`/sites/${siteId}/publish`, { publish });
  return data;
}
